import { render, staticRenderFns } from "./NotificationsListHeader.vue?vue&type=template&id=1ba859a6&scoped=true&"
import script from "./NotificationsListHeader.vue?vue&type=script&lang=js&"
export * from "./NotificationsListHeader.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsListHeader.vue?vue&type=style&index=0&id=1ba859a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba859a6",
  null
  
)

export default component.exports